import { render, staticRenderFns } from "./switchboxs1.vue?vue&type=template&id=6008b3c0&scoped=true&"
import script from "./switchboxs1.vue?vue&type=script&lang=js&"
export * from "./switchboxs1.vue?vue&type=script&lang=js&"
import style0 from "./switchboxs1.vue?vue&type=style&index=0&id=6008b3c0&prod&lang=scss&scoped=true&"
import style1 from "./switchboxs1.vue?vue&type=style&index=1&id=6008b3c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6008b3c0",
  null
  
)

export default component.exports